import { LoginForm } from '@/components/auth'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { useBranding } from '@/contexts/BrandingContext'
import { getPageStyles } from '@/utils/pageBranding'

export default function Login() {
  const { branding } = useBranding()
  const pageStyles = getPageStyles(branding)

  const fadeInLeft = {
    hidden: { opacity: 0, x: -60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, delay: 0.2 },
    },
  }

  const fadeInRight = {
    hidden: { opacity: 0, x: 60 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, delay: 0.4 },
    },
  }

  return (
    <motion.div
      className="min-h-screen flex items-center justify-center px-4"
      initial="hidden"
      animate="visible"
    >
      <div className="w-full max-w-7xl mx-auto">
        <div className="grid items-center gap-12 lg:grid-cols-2">
          {/* Left Content */}
          <motion.div
            className=""
            style={pageStyles.text}
            variants={fadeInLeft}
          >
            <Link
              to="/"
              className="inline-flex items-center text-gray-300 hover:text-white transition-colors mb-8"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Home
            </Link>

            <h1 className="mb-6 text-5xl font-bold leading-tight lg:text-6xl">
              Welcome Back to <span className="text-orange-400">PexiBlock</span>
            </h1>
            <p className="max-w-4xl mb-8 text-gray-300 text-lg">
              Sign in to your account to access your dashboard, manage your payments, and continue
              building with our card-to-crypto payment solutions.
            </p>

            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-orange-400 rounded-full"></div>
                <span className="text-gray-300">Secure authentication</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-orange-400 rounded-full"></div>
                <span className="text-gray-300">Instant dashboard access</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-orange-400 rounded-full"></div>
                <span className="text-gray-300">24/7 customer support</span>
              </div>
            </div>
          </motion.div>

          {/* Right Content - Login Form */}
          <motion.div className="flex justify-center lg:justify-end" variants={fadeInRight}>
            <div className="relative">
              {/* Background decorative elements */}
              <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute rounded-full -top-20 -right-20 w-40 h-40 bg-gradient-to-br from-orange-200/20 to-blue-200/20 blur-3xl animate-pulse-slow"></div>
                <div className="absolute rounded-full -bottom-20 -left-20 w-40 h-40 bg-gradient-to-tr from-blue-200/20 to-orange-200/20 blur-3xl animate-pulse-slow"></div>
              </div>

              <LoginForm />
            </div>
          </motion.div>
        </div>
      </div>
    </motion.div>
  )
}
